import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import TailSpinLoader from './components/TailSpinLoader';

const container = document.getElementById('root')
if(container) {
  const root = createRoot(container)
  root.render(
    <Suspense fallback={(<TailSpinLoader />)}>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Suspense>
  );

}


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
